module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av385-60764f1367b448a30a179ded1f4a7fca.jpg";